import { SET_LAST_UPDATED } from "constants/ActionTypes";
import { INITIAL_STATE } from "constants/AppConstants";

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_LAST_UPDATED:
      return {
        ...state,
        lastUpdated: action.payload
      };
    default:
      return state;
  }
};
